import { PaymentTypeEnum } from "ReactApp/Types/enum";
import { stringFormatter } from "ReactApp/Services/Formatters/StringFormatter";

class PaymentType
{
    private static _instance: PaymentType;

    public static get Instance() {
        return this._instance || (this._instance = new this());
    }

    asLabel(paymentType: PaymentTypeEnum, replacements: string[] = []): string {
        switch (paymentType) {
            case PaymentTypeEnum.cash:
                return 'Наличными или картой при получении';
            break;
            case PaymentTypeEnum.online:
                return 'Онлайн-оплата';
            break;
            case PaymentTypeEnum.yandexPayFullPayment:
                return 'Яндекс.Пэй (полная оплата)';
            break;
            case PaymentTypeEnum.yandexPaySplit:
                return 'Яндекс.Пэй (сплит-оплата)';
            break;
            case PaymentTypeEnum.dolyame:
                return 'Долями';
            break;
            case PaymentTypeEnum.onlineCredit:
                return 'Яндекс.Касса (в рассрочку)';
            break; 
        }
    }
}

export const paymentTypeTransformer = PaymentType.Instance;